import { MENU_DATA } from '@/const/index.js';
import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

const initialState = {
    currentGame: null,
    gameList: [],
    loading: false,
    error: null,
    isMobile: false,
    searchQuery: '',
    refreshKey: 0,
    shouldFilter: false,
    // TODO: 目录路由暂时由前端进行缓存
    menuData: MENU_DATA,
    // 目录点击数据记录
    categoryClickData: {
        currentPath: "",
    },
};

const gameSlice = createSlice({
    name: 'game',
    initialState,
    reducers: {
        setCurrentGame: (state, action) => {
            state.currentGame = action.payload;
        },
        setGameList: (state, action) => {
            state.gameList = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        // 页面初始化时需要配置的关键信息
        setIsMobile: (state, action) => {
          state.isMobile = action.payload;
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
            state.shouldFilter = true;
        },
        refreshGameList: (state) => {
            state.refreshKey += 1;
            state.searchQuery = '';
            state.shouldFilter = false;
        },
        setMenuData: (state, action) => {
            state.menuData = action.payload;
        },
        // 记录目录点击数据
        recordCategoryClick: (state, action) => {
            const { path } = action.payload;
            state.categoryClickData.currentPath = path;
        },
        // 清除目录点击数据
        clearCategoryClickData: (state) => {
            state.categoryClickData = {
                currentPath: "",
            };
        },
    },
    extraReducers: {
        [HYDRATE]: (state, action) => {
            // 处理服务器端状态和客户端状态的合并
            return {
                ...state,
                ...action.payload.game,
                // 保留客户端特定的状态
                loading: state.loading,
                error: state.error,
                isMobile: state.isMobile,
                refreshKey: state.refreshKey,
                shouldFilter: state.shouldFilter,
                // 合并 menuData，优先使用服务端数据
                menuData: action.payload.game?.menuData || state.menuData,
                // 保留客户端的点击数据
                categoryClickData: state.categoryClickData,
            };
        }
    }
});

export const { 
    setCurrentGame, 
    setGameList, 
    setLoading, 
    setError,
    setIsMobile,
    setSearchQuery,
    refreshGameList,
    setMenuData,
    recordCategoryClick,
    clearCategoryClickData,
} = gameSlice.actions;

export default gameSlice.reducer; 